import { DOCUMENT_DATA_TYPE, DOCUMENT_TYPE } from '@tencent/ark-model';
/**
 * 一个通用的将 DocumentData 或 OfflineData 转换为提交离线数据时发包的包体结构的工具对象
 */
var CommonChangeDataComposer = /** @class */ (function () {
    function CommonChangeDataComposer() {
    }
    /**
     * 将 DocumentData 或 OfflineData 转换为请求服务器的数据结构
     * 结构大致如下：
     * {
     *  common: {} // 公共信息字段
     *  respective: [{}, {}, {}], // 每个 Change Data 会生成对应的一个结构
     * }
     * @param changeData 待转换的数据
     * @returns 转换后的数据结构
     */
    Object.defineProperty(CommonChangeDataComposer, "compose", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (changeData, newDocumentParam) {
            var _a;
            // 同一组离线数据，公共参数取第一个就可以了
            var changeDataItem = changeData[0];
            var uid = changeDataItem.uid, globalPadId = changeDataItem.globalPadId, dataVersion = changeDataItem.dataVersion;
            var changeDataItemData = JSON.parse(changeDataItem.data);
            // base revision
            var baseRev = changeDataItem.type === DOCUMENT_DATA_TYPE.init
                ? changeDataItem.version : changeDataItemData.baseVersion;
            // code version，老的注释：pVer，表格为1，文档/slide为0
            var codeVer = changeDataItem.docType === DOCUMENT_TYPE.sheet ? 1 : 0;
            // 这里被坑了太久，请勿改回，word melo里面改成2 ，升级数据，core-doc 是1
            var pVer = changeDataItem.docType === DOCUMENT_TYPE.doc ? 2 : 1;
            // uuid
            var uuId = changeDataItem.type === DOCUMENT_DATA_TYPE.init ? uid : changeDataItemData.data.uuId;
            // ❌❌❌：其中的若干带下划线的字段命名是因为 CGI 定义的数据结构字段是这样的，必须对齐。
            var content = {
                common: {
                    uid: uid,
                    type: 'USER_CHANGES',
                    offlineMsg: true,
                    docid: (_a = newDocumentParam === null || newDocumentParam === void 0 ? void 0 : newDocumentParam.globalPadId) !== null && _a !== void 0 ? _a : globalPadId,
                    dver: dataVersion,
                    base_rev: baseRev,
                    code_ver: codeVer,
                    session_type: 0,
                    gray: 0,
                    // TODO 这里看看怎么取
                    // generalpacket: this.getHeaderGeneralPacket(),
                    pver: pVer,
                    uuId: uuId,
                },
                respective: changeData
                    // 过滤掉 init 类型的数据
                    .filter(function (item) { return item.type !== DOCUMENT_DATA_TYPE.init; })
                    // 转换 change data 为对应的数据项
                    .map(function (item) {
                    var _a, _b;
                    var data = JSON.parse(item.data).data;
                    var result = {
                        task_id: data.taskId,
                        subId: data.subId,
                        oSubId: (_a = data.oSubId) !== null && _a !== void 0 ? _a : false,
                        head: data.head,
                        keydata: (_b = data.keyData) !== null && _b !== void 0 ? _b : false,
                        changeSetCount: data.changeData
                            ? 1 : data.changeSetCount !== undefined ? data.changeSetCount : data.mutations.length,
                        changeset: (data.changeset ? data.changeset : JSON.stringify(data.changeData || data.mutations || '[]')),
                        apool: data.apool,
                    };
                    if (changeDataItem.docType === DOCUMENT_TYPE.sheet) {
                        result.changeset = "".concat(result.changeset, "\n");
                    }
                    return result;
                }),
            };
            return content;
        }
    });
    return CommonChangeDataComposer;
}());
export { CommonChangeDataComposer };
